import { DialogActions } from '@mui/material';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchDetails } from '../../../../../../../../../../../../../lib/api/creditRequest';
import { getExecutivesAvailableForFactoring } from '../../../../../../../../../../../../../lib/api/factoring';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import { hasAnyPermissions } from '../../../../../../../../../../../../../lib/functions/utils';
import CreditRequestStatus from '../../../../../../../common/CreditRequestStatus';
import Summary from '../../../../../create/components/Simulator/components/Summary';

const ShoppingCartAccepted = (props: any) => {
  const {
    setOpenShoppingCart,
    openRequest,
    setUp,
    setSuccessOpen,
    setFailureOpen,
    setSelectedRequest,
  } = props;
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const [loading, setLoading] = useState(false);

  const [executivesPortfolio, setExecutivesPortfolio] = useState([]);
  const [executivesAll, setExecutivesAll] = useState([]);

  const canEditExecutive = hasAnyPermissions(user, ['financing_credit_edit']);

  const allowEditExecutive =
    canEditExecutive && openRequest.status === 'Activa';

  const fetchExecutives = async () => {
    if (openRequest?.businessIdentifier) {
      try {
        const response = await getExecutivesAvailableForFactoring(
          dispatch,
          openRequest.businessIdentifier,
        );
        setExecutivesPortfolio(response.usersWithBusinessInPortfolio);
        setExecutivesAll(response.allUsers);
      } catch (error) {
        console.error('Error fetching executives:', error);
      }
    }
  };

  const reloadCreditDetails = async () => {
    setLoading(true);
    try {
      const updatedRequest = await fetchDetails(dispatch, openRequest.id);
      if (setSelectedRequest) {
        setSelectedRequest(updatedRequest);
      }
    } catch (error) {
      console.error('Error reloading credit details:', error);
      if (setFailureOpen) {
        setFailureOpen('Error al recargar los datos del crédito');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleExecutiveChange = async () => {
    await reloadCreditDetails();
  };

  useEffect(() => {
    if (allowEditExecutive) {
      void fetchExecutives();
    }
  }, [allowEditExecutive, openRequest?.businessIdentifier]);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <div>
        <CreditRequestStatus
          openRequest={openRequest}
          audienceType="received"
          allowEditExecutive={allowEditExecutive}
          executivesPortfolio={executivesPortfolio}
          executivesAll={executivesAll}
          onExecutiveChange={handleExecutiveChange}
          creditRequestId={openRequest.id}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
        />
        <Summary
          creditDetails={openRequest}
          amortizationSchedule={openRequest.documents}
        />
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartAccepted;
